import SignOut from '@clearkit/icons/glyphs/Signout';
import Logo from '@clearkit/icons/identity/X';
import { CKButton } from '@clearkit/react';
import { Subscribe } from 'unstated';

import CompanyLogo from '~/components/CompanyLogo';
import LoadingArea from '~/components/LoadingArea';
import UserContainer from '~/containers/User';

import styles from './styles.style';

const accountCanAccessX = (account) => account.permissions.can_access_x;

class NoAccess extends React.Component {
  renderAccount = (account) => {
    const { classes, currentAccountId, switchAccount } = this.props;

    return (
      <div className={classes.account} key={account.id}>
        {account.name}

        {account.id === currentAccountId ? (
          <span className={classes.currentIndicator}>Current</span>
        ) : (
          <div className={classes.actions}>
            {accountCanAccessX(account) ? (
              <CKButton
                mini
                isSmall
                variantColor="blue"
                variant="bold"
                className={classes.switchMessage}
                onClick={() => switchAccount(account.id)}>
                Switch to team
              </CKButton>
            ) : (
              <span className={classes.noAccess}>No X access</span>
            )}
          </div>
        )}
      </div>
    );
  };

  render() {
    const { accountDomain, accounts, email, classes } = this.props;
    const hasAccessInAnotherTeam = accounts.find(accountCanAccessX);

    return (
      <div className={classes.root}>
        <Logo className="mb-8" width={72} height={72} />

        {hasAccessInAnotherTeam ? (
          <>
            <h2 className={classes.heading}>
              Switch teams to access Clearbit{' '}
              <span className={classes.headingX}>X</span>
            </h2>
            <p className={classes.paragraph}>
              Your current team does not have access. Switch to another team to
              continue or{' '}
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="mailto:success@clearbit.com">
                get in touch
              </a>{' '}
              to make changes to your plan.
            </p>
          </>
        ) : (
          <>
            <h2 className={classes.heading}>
              Sorry, you don’t have access to Clearbit{' '}
              <span className={classes.headingX}>X</span>
            </h2>
            <p className={classes.paragraph}>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="mailto:success@clearbit.com">
                Get in touch
              </a>{' '}
              for more information or if you believe you should already have
              access.
            </p>
          </>
        )}

        <div className={classes.accounts}>
          <div className={classnames(classes.account, 'bg-gray-0')}>
            <CompanyLogo domain={accountDomain} className={classes.avatar} />
            {email}
            <div className={classes.actions}>
              <a href="/logout" className="flex items-center">
                <SignOut className="inline mr-2 text-gray-600" />
                Sign out
              </a>
            </div>
          </div>
          {hasAccessInAnotherTeam && accounts.map(this.renderAccount)}
        </div>
      </div>
    );
  }
}

NoAccess.propTypes = {
  classes: PropTypes.object,
  accountDomain: PropTypes.string.isRequired,
  currentAccountId: PropTypes.string.isRequired,
  email: PropTypes.string,
  domainForAccount: PropTypes.func.isRequired,
  accounts: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      xAccess: PropTypes.bool,
    }),
  ),
};

const WrappedNoAccess = (props) => (
  <Subscribe to={[UserContainer]}>
    {(userContainer) => {
      const {
        accountDomain,
        domainForAccount,
        currentAccountId,
        switchAccount,
        state: { accounts, currentUser },
      } = userContainer;

      return (
        <LoadingArea loading={!currentUser}>
          <NoAccess
            accounts={accounts}
            switchAccount={switchAccount}
            email={currentUser && currentUser.email}
            accountDomain={accountDomain()}
            currentAccountId={currentAccountId()}
            domainForAccount={domainForAccount}
            {...props}
          />
        </LoadingArea>
      );
    }}
  </Subscribe>
);

export default withStyles(styles)(WrappedNoAccess);
